<template>
  <meter-record-crud
    :allowed-fee-types="[2, 4]"
    page-title="水·污水 — 抄表明细台账"
    direct-usage-entry
  />
</template>

<script>
import MeterRecordCrud from './MeterRecordCrud.vue'

export default {
  name: 'MeterEnergyRecordWaterSewage',
  components: { MeterRecordCrud }
}
</script>
